<template>
  <div class="IncrementalData-fieldWrap">
    <div class="IncrementalData-field">
      <p class="IncrementalData-supportingText">
        What do YOU want the RMP Team to email you about?
      </p>
      <div
        class="IncrementalData-question"
      >
        <label
          class="IncrementalData-questionText"
        >
          Contact Preferences
        </label>
        <div class="IncrementalData-questionField">
          <form-checkbox
            v-model="fields.jobs_subscription"
            :value="1"
            label="Job alerts"
            data-rmpdev-field-selector="jobs_subscription"
          />
          <p class="Hint">
            NEW (and relevant) jobs direct to your inbox... With expert careers advice
          </p>
          <form-checkbox
            v-model="fields.competitions_subscription"
            :value="1"
            label="Competitions and surveys"
            data-rmpdev-field-selector="competitions_subscription"
          />
          <p class="Hint">
            Complete surveys & competitions to win prizes from employers
          </p>
          <form-checkbox
              v-model="fields.courses_subscription"
              :value="1"
              label="Apprenticeship Accelerator"
              data-rmpdev-field-selector="courses_subscription"
          />
          <p class="Hint">
            Opt in to receive exclusive invites to our free Apprenticeship Accelerator. This two-part virtual event series provides all the tools you need to kickstart your career
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FormCheckbox from '@/components/form/checkbox';
import useVuelidate from '@vuelidate/core';
import incrementalMixin from '../mixins/incremental-data-field-mixin';

export default {

  components: {
    FormCheckbox,
  },
  mixins: [incrementalMixin],

  data() {
    return {
      v$: useVuelidate(),
      fields: {
        jobs_subscription: null,
        competitions_subscription: null,
        courses_subscription: null,
      },
      fieldName: 'subcriptions',
    };
  },

  computed: {
    updatePayload() {
      return {
        jobs_subscription: this.fields.jobs_subscription ? 1 : 0,
        competitions_subscription: this.fields.competitions_subscription ? 1 : 0,
        courses_subscription: this.fields.courses_subscription ? 1 : 0,
        subscription_decision: 1,
      };
    },
  },

  validations() {
    const rules = {
      fields: {
        jobs_subscription: {},
        competitions_subscription: {},
        courses_subscription: {},
      },
    };

    return rules;
  },
};
</script>
<style scoped>
.Hint {
  margin-top: -1rem;
}
</style>
